import { useEffect } from 'react';
import schemesSagaWatcher from '../store/sagas';
import schemesReducer from '../store';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useSchemesChunk = () => {
    useEffect(() => {
        injectReducer('schemes', schemesReducer);
        injectSaga('schemes', schemesSagaWatcher);
    }, []);
};
